export const formatPublicationDistance = (
  distance?: number,
): string | undefined => {
  if (!distance) {
    return undefined;
  }

  if (distance >= 1000) {
    return `${Math.floor(distance / 1000)}km`;
  }

  return `${distance}m`;
};
